module.exports = "<div><textarea class=\"mwInputNode mwAlignmentNode\" data-dojo-attach-point=\"inputNode,focusNode\" spellcheck=\"false\"></textarea></div>"